export default function mapProductVariantAttributes(variant) {
  const {
    product: { id, sku, image: img, media_gallery },
    attributes
  } = variant;

  const colorAttribute = attributes?.filter(
    attribute => attribute.code === 'v__rv'
  )[0];

  const color = colorAttribute?.label;
  const colorUID = colorAttribute?.uid;
  let image = { label: img?.label };
  if (img?.url?.includes('placeholder') && media_gallery?.length) {
    image = { ...img, url: media_gallery[0]?.url };
  } else {
    image = { ...img, url: img?.url };
  }

  return { id, sku, image, media_gallery, color, colorUID };
}
